import "./broad_video.css";
import _com from "../../assets/js/common";
import cookie from "@/assets/js/cookie"
import { formatDate } from "../../assets/js/date";
import { unJsonp } from "../../assets/js/http";
import jsonp from "../../assets/js/http";
import { Component, Vue, Watch } from "vue-property-decorator";
import topModular from "../../theme/components/topModular/topModular.vue";
import message from "../../theme/components/message/message.vue";
import leftModal from "../../theme/components/leftModal/index.vue";
import rightModal from "../../theme/components/rightModal/index.vue";
import detailComp from "./components/detail/detailComp.vue";

import goodsModal from "../../theme/components/goosModal/modal.vue";
import goodsDetail from "../../theme/components/ylxdsqGoods/ylxdsqDetail.vue";
import goodsCart from "../../theme/components/ylxdsqGoods/ylxdsqCart.vue";
import luckCardModal from "../../theme/components/luckCardModal/luckCardModal.vue";
import luckCardList from "../../theme/components/luckCardModal/luckCardList.vue";
import operatModal from "../../theme/components/operatModal/modal.vue";
import reportModal from "../../theme/components/reportModal/modal.vue";
import conponModal from "../../theme/components/couponModal/modal.vue";
import changeConponModal from "../../theme/components/changeCoupon/modal.vue";
import luckDialog from "../../theme/components/luckDialog/dialog.vue";
import luckHistoryDialog from "../../theme/components/luckHistoryDialog/dialog.vue";
import setPhone from "../../theme/components/setPhone/dialog.vue";
import PacketRain from '../../theme/components/packetRain/packetRain.vue'
import yzfdComponent from '../../theme/components/yzfdComponent/index.vue'
import _intercept from "@/assets/js/intercept";

@Component({
	components: { goodsModal, goodsDetail, goodsCart, luckCardModal, luckCardList, operatModal, leftModal, rightModal, reportModal, conponModal, changeConponModal, topModular, message, luckDialog, luckHistoryDialog, setPhone, PacketRain, yzfdComponent, detailComp },
})
export default class broadLive extends Vue {
	roomData: any = {
		goods: [],
		cover: "",
	}; //直播间数据
	isRecording: boolean = false //是否录播
	isSection: boolean = false //是否录播切片
	isquery: boolean = false //是否正在请求直播地址
	recordHsl: string = ''
	isplay: boolean = false //是否正在播放
	currentDate: any = '' //当前日期
	currentTime: any = "00:00" //当前时间
	duration: any = "00:00" //总时长
	pvideo: any = null //视频容器
	timer: any = null //定时器
	timeStep: number = 1000
	api: any = {
		definition: "https://pub" + this.domain + "/live/api/out/play/changeHlsDefinition", //获取中奖状态
		whippedEgg: "https://service" + process.env.VUE_APP_URI_DOMAIN + "/appact/promotion/syncPromotionInfo",//掼蛋
		getM3u8: process.env.VUE_APP_URI_CDNDOMAIN + "/live/api/out/play/room",
		getStatus: process.env.VUE_APP_URI_CDNDOMAIN + "/live/api/out/room/status/", //获取直播间状态
		getisLucky: "https://pub" + this.domain + "/ulelivebarrage/api/v1/room/luck/user/", //获取中奖状态
		submitLike: "https://pub" + this.domain + "/ulelivebarrage/api/v1/room/like/submit", //提交点赞接口 post room_name  likes
		// redRainCode: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/room/red_rain_code", //直播间红包雨活动码查询接口
		redRainCode: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/room/getAllRedRainCode", //直播间红包雨活动码查询接口
		posterInfo: "https://pub" + process.env.VUE_APP_URI_DOMAIN + "/live/tv/poster/",//获取海报信息
		shareInfo: "https://pub" + process.env.VUE_APP_URI_DOMAIN + "/live/tv/share/",//获取分享信息
		queryInvitationCode: "https://pub" + this.domain + "/live/api/invite/checkUser/",// 查询用户是否填写过邀请码
		fillInvitationCode: "https://pub" + this.domain + "/live/api/invite/inviteUser/",// 邀请用户填写邀请码
		live_room_redrain_text: "//ustatic" + process.env.VUE_APP_URI_ULECDNDOMAIN + "/common-recommend-cdn/v2/recommend/indexFeaturedGet/live_room_redrain_text/0/live_room_redrain_text" // 红包规则
	};

	prevTime: any = 0
	isGoodsOut: boolean = false;
	online: boolean = true; //网络是否在线
	notice: String = "";
	noticeBool: boolean = false;
	isShowLoading: boolean = false; //是否显示loading
	showPlayBtn: boolean = true;
	isShowReport: boolean = false;//是否显示投诉列表
	browser = _com.browser();
	isVideo: boolean = false;
	currentRate: any = 100
	currentRateText: any = 15
	timeInter: any = null;
	m3u8Timer: any = null;
	difference: any = 0;//当前时间与服务器时间差
	userEnterTime: any = new Date().getTime();//用户进入时记录时间
	errorNum = 0;
	showPoster = false;
	loadingText = "加载中...";
	dialogBtn = false;
	isSetPhoneHint = false
	luckHistoryTime = 0
	showCenter: any = false
	clickNum = 0
	isShowLuckHistory = true
	luckHistoryData = { prizeArr: [], isPrize: false }
	// 红包雨信息
	isPc: boolean = _com.isPc()
	isYzs: boolean = _com.isYzs()
	// 红包雨错误信息
	popFailData: any = {
		title: "",
		text: " ",
	}
	lotteryMouth: any = false
	// 红包雨场次
	weekFeilds: any = []
	isFlashData: Boolean = false
	isPacketStart: boolean = false // 开始红包雨
	packetStatus: number = 3 // 红包雨活动状态，1 预热，2 开始，3 结束
	packetPreTime: number = 10000 // 红包雨倒计时
	cardNumber: number = 0 // 集卡卡片数量
	isPacketFail: boolean = false // 抽奖失败
	isPacketSucc: boolean = false // 抽奖成功   h5红包雨
	isShowCard: boolean = false // 获得招财卡弹框
	isShowCardPrize: boolean = false // 获得招财卡奖品弹框
	isHasCard: boolean = false // 获得招财卡
	shareNowTimes: number = 0 // 分享次数
	// 活动code集合
	activityCode: any = {
		couponCode: "", // 领券活动code
		packetCode: "", // 红包雨抽奖code
		shareCode: "", // 分享抽奖code
		floorCode: "", // 楼层活动编号
		cardCode: "", // 集卡抽奖
		cardExchangeCode: "", // 4张卡片触发抽奖
		cardInfoCode: "" // 集卡信息
	}
	channel: string = ""; // 渠道
	award: any = []; // 中奖信息
	isBaseTimeUse: boolean = false
	// 分享相关
	shareConfig: any = {
		isShare: false, // 是否显示分享
		shareInfo: {
			shareTitle: "", // 分享名称
			shareContent: "", // 分享描述
			itemPic: "", // 分享图片
			activityId: "" // 活动code - 楼层code
		}
	}
	isWinningRecord: any = false
	ruleData: any = [] // 活动规则
	weekFeildIndex: number = 0 // 红包雨所在的场次次序
	baseTimes: number = 0 // 基础抽奖次数
	prizeInfos: any = {}//抽奖奖品
	showDown: any = false
	succCount: any = 0;//击中红包数量
	countDown: any = 1000
	followData: any
	thumbsUpTime: any = null
	thumbsUpBoolen: Boolean = false
	isInvitationLive: Boolean = true // 不出现邀请码输入弹窗
	activeGoodsData: any
	invitationCode: any = ''
	showCountdown: any = false
	statement: any = ''
	userPhoneNumber: any = {
		contactNumber: '',
		contactPhone: ''
	}

	isShoWanimating: any = false
	startX: any = 0
	startTime: any = 0
	slideVaild: any = false
	cutoutImage: any = ''
	shadeImage: any = ''
	imgX: any = 0
	imgY: any = 0
	postion: any = ''
	moveCount: any = 0
	windowWidth: any = document.body.clientWidth
	mouseoverInfo: any = ''
	errTips: any = false
	checkCode: any = ''
	dataKey: any = ''
	useTime: any = 0
	get isShowDetailInfo() {
		return this.$store.getters["environment/getIsShowDetailInfo"];
	}
	set isShowDetailInfo(val: boolean) {
		this.$store.dispatch("environment/getIsShowDetailInfoAsync", val);
	}
	get isGoodsList() {
		return this.$store.getters["environment/getIsGoodsList"];
	}
	get isGoodsDetail() {console.log('asdfghj');
		
		return this.$store.getters["environment/getIsGoodsDetail"];
	}
	get isYlxdsqCart() {
		return this.$store.getters["environment/getIsYlxdsqCart"];
	}
	get isElderlyMode() {
		return this.$store.getters["environment/getElderlyMode"];
	}
	get isShowOperat() {
		// if (this.$store.getters["environment/getIsShowOperat"]) {
		// 	setTimeout(() => {
		// 		let overlay = <HTMLImageElement>document.querySelector('.van-overlay')
		// 		overlay.style.background = 'transparent'
		// 		// document.querySelectorAll('.van-overlay')[2].background = 'transparent'
		// 	}, 20);
		// }
		return this.$store.getters["environment/getIsShowOperat"];
	}
	get getRoomData() {//房间数据
		return this.$store.getters["getRoomDetail/getRoomDetail"];
	}
	get luckCardAllData() {
		let data: any = this.$store.getters["refresh/getLuckCardAllData"];
		return data;
	}
	get useronlyid() {
		//用户id
		return this.$store.getters["getUserOnlyId/getUserOnlyId"];
	}
	get isShowConpon() {
		return this.$store.getters["environment/getIsShowConpon"];
	}
	get likeNum() {
		return this.$store.getters["timing/getLike"];
	}
	get clearScreen() {
		return this.$store.getters["environment/getClearScreen"];
	}

	get goodsList() {
		let list: Array<any> = this.$store.getters["refresh/getGoodsList"];
		return list
	}
	get isShowPrize() {
		return this.$store.getters["refresh/getIsShowPrize"];
	}
	get isShowPrizeHistory() {
		if (this.$store.getters["refresh/getIsShowPrizeHistory"]) {
			this.getisLucky()
		}
		return this.$store.getters["refresh/getIsShowPrizeHistory"];
	}
	get luckHistory() {
		let history = this.$store.getters["refresh/getLuckHistory"];
		if (history.status == 2 && this.luckHistoryTime <= 1) {
			this.isShowLuckHistory = true
			this.luckHistoryTime += 1
			console.log(this.luckHistoryTime);

		}
		return history;
	}
	get isSetPhone() {
		return this.$store.getters["refresh/getIsShowPhoneHint"];
	}
	get isFirstPrize() {
		return this.$store.getters["refresh/getIsFirstPrize"];
	}

	get goodsMaterial() {
		return this.$store.getters["refresh/getGoodsMaterial"];
	}

	get videoStatus() {
		let data = this.$store.getters["getRoomDetail/getStatus"];
		if (this.isRecording) {
			data.tvStatus = 1
		}
		if (data.roomStatus == "1" && data.tvStatus == 0) {
			//断流
			if (!this.showPlayBtn) {
				this.loadingText = "主播暂时离开了";
				this.isShowLoading = true;
			}
			this.m3u8Timer = setTimeout(() => {
				this.isVideo = false;
				this.getHls();
			}, 5000);
		} else if (data.roomStatus == "1" && data.tvStatus == 1) {
			//直播中
			//this.showPoster=true;
		} else if (data.roomStatus == "0" || data.roomStatus == "2") {
			//0未开播  2关播
			this.isVideo = false;
			this.showPlayBtn = false;
		}
		return data;
	}

	// @Watch('isShowPrize') //2022/6/7  中奖用户前置条件改为必有手机号    
	// onChange(val:any,oldVal:any){
	// 	if(!val){
	// 		this.$store.dispatch("refresh/getPhoneAsync", {
	// 			scene_id: this.roomData.scene_id
	// 		}).then((res)=>{
	// 			this.isSetPhoneHint = true
	// 		});
	// 	}
	// }
	@Watch('luckHistoryTime')
	onLuckHistoryTimeChange(val: any, oldVal: any) {
		console.log(val);
		if (val < 3) {
			if (this.luckHistory.status == 2) {
				setTimeout(() => {
					this.luckHistoryTime += 1
				}, 2000);
			}
		} else if (val == 3) {
			let timer1 = setInterval(() => {
				if (this.luckHistory.status == 3) {
					this.luckHistoryTime = 4;
					clearInterval(timer1)
				}
			}, 2000)
		} else {
			setTimeout(() => {
				this.luckHistoryTime = 1
			}, 5000);
		}
	}
	// get hlsURL(){//切换画质使用
	//     let obj = this.$store.getters["environment/getHls"];
	//     if(obj.url !='' && obj.isSelected){
	//         let video:any = document.getElementById('video');
	//         video.src =obj.url;
	//         video.load();
	//     }
	//     return obj;
	// }
	openShow({ roomData }: any) {
		if (!_intercept()) {
			return false;
		}
		let url = `//pub${process.env.VUE_APP_URI_DOMAIN}/live-service/api/v1/enterpriseCert/info`
		jsonp(url, {
			client_type: 'h5',
			baseId: this.roomData.id,
			jsonp: 'callback'
		}).then((data: any) => {
			console.log(data, 'dataaa');
			if ((data.userSource == 1 || data.userSource == 3) && data.enterpriseCode?.length > 0) {
				this.$store.dispatch("environment/getIsShowDetailInfoAsync", true);
				this.$nextTick(() => {
					if (this.$refs.detailComp) {
						(this.$refs.detailComp as any).getDetailInfo(data);
					}
				});
			} else if (data.userSource == 2 && data.mobile && data.mobile?.length > 0) {
				this.$store.dispatch("environment/getIsShowDetailInfoAsync", true);
				this.$nextTick(() => {
					if (this.$refs.detailComp) {
						(this.$refs.detailComp as any).getDetailInfo(data);
					}
				})
			}
		})

	}
	handleMouseDown(e: any) {
		const rightBtn: any = document.querySelector('.rightBtn');
		const validateContent: any = document.querySelector('.validateContent');
		this.startTime = new Date().valueOf()
		this.startX = (e.clientX || e.touches[0].clientX) - rightBtn.offsetLeft + validateContent.offsetLeft
	}
	handleMouseUp() {
		(window as any).uleStatUtil.sendView(location.href, { relateType: 'redPackets', relateId1: this.roomData.scene_id, relateId2: this.activityCode.packetCode });
		this.moveCount = 0
		this.useTime = (new Date().valueOf()) - this.startTime
		this.mouseoverInfo = this.mouseoverInfo.substr(0, this.mouseoverInfo.length - 1)
		let url = `https://service${process.env.VUE_APP_URI_DOMAIN}/lottry/lottery/lottry`
		let channel: any = {
			'usq': '610001',
			'ule': '300000',
			'uxd': '600000',
			'uleapp': '200000',
		}
		jsonp(url, {
			key: this.dataKey,
			x: parseInt(this.imgX),
			useTime: this.useTime,
			y: parseInt(this.imgY),
			mouseoverInfo: this.mouseoverInfo,
			activityCode: this.activityCode.packetCode,
			channel: channel[this.source] || '200000',
			liveRoomNum: this.$route.params.roomNumber,
			fieldId: "",
			deviceId: ""
		}).then((data: any) => {
			let prizeInfos: any = data.content.prizeInfos[0];
			if (prizeInfos.prizeTypeDesc_v2 == '40600') {//2022.10.21余陈德确认50503奖品下线了，改为40600
				// if(prizeInfos.prizeType=='50503'){//产品确认将奖品类型40600改为50503
				this.isPacketSucc = true;
				//抽中活动奖励金
				this.prizeInfos = prizeInfos;
			} else {
				//其他奖品,目前只有活动奖金，万一设置错误给用户显示没抽中的提示
				this.packetFail({
					title: "这次没抢到哦换个姿势试试吧",
					text: " ",
				})
			}
			this.isShoWanimating = false
			this.$forceUpdate()

		}).catch(((res: any) => {
			if (res.code == '99785') {
				this.resetValidate()
				return
			}
			this.packetFail({
				title: "这次没抢到哦换个姿势试试吧",
				text: " ",
			})
			this.isShoWanimating = false
		}))
	}
	handleMouseMove(e: any) {
		const imgBtn: any = this.$refs.imgBtn
		const rightBtn: any = this.$refs.rightBtn
		this.imgX = (e.clientX || e.touches[0].clientX) - this.startX
		imgBtn.style.left = (e.clientX || e.touches[0].clientX) - this.startX + 'px'
		rightBtn.style.left = (e.clientX || e.touches[0].clientX) - this.startX + 'px'
		if (this.moveCount % 10 == 0) {
			const timeDiff = ((new Date()).valueOf()) - this.startTime;
			this.mouseoverInfo += (parseInt(this.imgX) + "|" + this.imgY + "|" + timeDiff + ",");
			console.log(this.mouseoverInfo)
		}
		const hkwrap: any = document.querySelector('.hkwrap');
		const imgBtns: any = document.querySelector('.imgBtn');
		this.moveCount++
		if (this.imgX <= 0) {
			this.imgX = 0
			imgBtn.style.left = '0px'
			rightBtn.style.left = '0px'
			console.log(this.startX)
		} else if (this.imgX > hkwrap.offsetWidth - imgBtns.offsetWidth) {
			this.imgX = hkwrap.offsetWidth - imgBtns.offsetWidth
			imgBtn.style.left = hkwrap.offsetWidth - imgBtns.offsetWidth + 'px'
			rightBtn.style.left = hkwrap.offsetWidth - imgBtns.offsetWidth + 'px'
		}
		e.preventDefault();
	}


	getValidate() {
		const callback = 'h5'
		jsonp(`https://service${process.env.VUE_APP_URI_DOMAIN}/appact/redenvelopes/getCodeImage`, {
			jsoncallback: callback
		}).then((data: any) => {
			this.cutoutImage = 'data:image/png;base64,' + data.cutoutImage
			this.shadeImage = `background:url(data:image/png;base64,${data.shadeImage}) center center`
			this.imgX = data.x
			this.imgY = data.y
			this.postion = `top:${this.imgY}px;left:${this.imgX}px`
			this.dataKey = data.key
		})
	}
	resetValidate() {
		this.errTips = true
		document.getElementsByClassName('validateContent')[0].classList.add("shake")
		this.getValidate()
		setTimeout(() => {
			document.getElementsByClassName('validateContent')[0].classList.remove("shake")
		}, 1000);
		let imgBtn: any = document.querySelector('.imgBtn')
		let rightBtn: any = document.querySelector('.rightBtn')
		imgBtn.style.left = 0
		rightBtn.style.left = 0
	}

	mounted() {
		// if(_com.isIos())
		//     this.showPlayBtn = true;
		this.getValidate()
		if (location.href.includes('browse_tag=1') && _com.getMallCookie()) {
			this.showDown = true
			let countdown = setInterval(() => {
				this.currentRate = Math.ceil(this.currentRate - 7)
				this.currentRateText = this.currentRateText - 1
				if (this.currentRateText <= 0) {
					let channel = '300000'
					if (this.browser.ule) channel = '200000'
					if (this.browser.ulexcx) channel = '800001'
					if (this.browser.ylxd) channel = '600000'
					if (this.browser.ylxdsq) channel = '610002'
					if (this.browser.usqxcx) channel = '610001'
					if (this.browser.usqh5) channel = '610003'
					if (this.browser.yzgxd) channel = '400006'
					if (this.browser.yshapp) channel = '500004'
					let pageId = this.$route.params.roomNumber
					let pageType = 'live'
					let event = "browse"
					let userOnlyId = this.useronlyid
					this.$http
						.jsonp(`${this.api.whippedEgg}?channel=${channel}&pageId=${pageId}&pageType=${pageType}&event=${event}&userOnlyId=${userOnlyId}`, {
							jsonp: "jsoncallback",
							jsonpCallback: "jsoncallback",
						}).then((data: any) => {
							if (data.body.code == '0000') {
								this.$toast('恭喜您获得1次掼蛋机会')
							}
						})
					clearInterval(countdown)
					this.showDown = false
				}
			}, 1000);
		}
		(<any>window).onresize = (() => {
			return (() => {
				this.windowWidth = document.documentElement.clientWidth
			})()
		})
		if (location.href.includes('borderless')) {
			let boxDom: any = document.getElementsByClassName('broadliveBox')[0]
			let rigDom: any = document.getElementsByClassName('rightBox')[0]
			let liveDom: any = document.getElementsByClassName('broadlive')[0]
			boxDom.style.padding = 0;
			rigDom.style.width = "50%"
			liveDom.style.width = "100%"
		}
		this.init();
		this.hideNotice();
		// this.setShareConfig();
		if (this.browser.weixin || this.browser.wxwork) {
			this.wxConFig(false)
		}
		window.onpageshow = (event: any) => {
			if (event.persisted) this.back();
		};
		// this.channel = _com.isPc() ? "400002" : "400001" // 邮掌柜APP 400001, 邮掌柜批销PC 400002
		// 红包雨开关
		// this.isPacketStart = true;
		console.log('页面参数', this.$route.params)
	}
	activeGoods(data: any) {
		this.activeGoodsData = data
	}
	countDownEnd() {  // 倒计时结束
		let partakeDraw: any = this.$refs.topModular
		partakeDraw.countDownEnd()
	}
	fatherPartakeDraw() {
		let partakeDraw: any = this.$refs.topModular
		partakeDraw.partakeDraw()
		let burialPoint = {
			url: location.href,
			ule_title: '直播间',
			resource_type: '直播间-抽奖浮标',
			resource_forward_url: '',
			// remarks: this.$route.params.roomNumber,
			scene_number: this.roomData.scene_number,
			roomNumber: this.$route.params.roomNumber
		}
		_com.sendSensorTrack('resourceClick', this.roomData, burialPoint, true, 'yshPoint')
	}
	knowFn() {
		this.showCenter = false
	}
	learnMore() {

		this.$http
			.jsonp(this.api.live_room_redrain_text, {
				jsonp: "jsonpCallback",
				jsonpCallback: "live_room_redrain_text",
			}).then((data: any) => {
				if (data.body.returnCode == '0000') {
					this.statement = data.body.indexInfo[0].show_text
					this.isPacketSucc = false
					this.showCenter = true
				}
			})
	}
	fatherTakeNotes() {
		let partakeDraw: any = this.$refs.topModular
		partakeDraw.takeNotes()
		let burialPoint = {
			url: location.href,
			ule_title: '直播间',
			resource_type: '直播间-中奖浮标',
			resource_forward_url: '',
			// remarks: this.$route.params.roomNumber,
			scene_number: this.roomData.scene_number,
			roomNumber: this.$route.params.roomNumber
		}
		_com.sendSensorTrack('resourceClick', this.roomData, burialPoint, true, 'yshPoint')
	}
	downData(data: any) {
		this.showCountdown = data.lotteryMouth
		this.countDown = data.countDown
		this.isWinningRecord = data.isWinningRecord
	}
	fatherFlashStatus() {
		let message: any = this.$refs.message
		message.flashStatus()
	}
	isFlash(data: any) {
		this.isFlashData = data
	}
	recruitPersonnel() {
		if (!_intercept()) {
			return false;
		}
		location.href = `https://h5${this.domain}/hd/liveBroadcast/application/lication.html?roomNumber=${this.roomData.roomNumber}&roomId=${this.roomData.id}&sceneId=${this.roomData.scene_id}`;
	}
	beforeDestroy() {
		this.$store.dispatch("refresh/setInsuranceAsync", []);
	}
	followStatus(data: any) {
		this.followData = data
	}
	showBindPhoneHint() {//打开绑定手机号弹窗
		this.isSetPhoneHint = true
	}

	closePhoneHint() {//关闭绑定手机号弹窗
		this.isSetPhoneHint = false
	}
	definition(data: any) {
		let url = `${this.api.definition}?roomName=${this.$route.params.roomNumber}&definition=${data}&callback=definitionStatus`
		jsonp(url, {
			jsonp: "definitionStatus",
			jsonpcallback: 'definitionStatus'
		}).then(
			(data: any) => {
				this.setVideo(data.hlsURL)
				this.$toast('切换成功')
			},
		);
	}
	back() {
		this.isVideo = false;
		this.hideGoodsList(false);
		this.init();
	}
	closeLuckHistory() {
		this.isShowLuckHistory = !this.isShowLuckHistory
	}
	//订阅暂停事件
	stopPlay() {
		if (this.pvideo.paused) {
			this.pvideo.play()
		} else {
			this.pvideo.pause();
		}
	}

	determine() {
		if (this.invitationCode.length < 1) {
			this.$toast('请输入邀请码')
		} else {
			if (!_intercept()) {
			} else {
				let getRoomData = this.getRoomData
				let callback = 'callback'
				let url = `${this.api.fillInvitationCode}${this.$route.params.id}/${getRoomData.scene_id}/${this.invitationCode}/${Math.floor(new Date().getTime() / 5000)}/` + callback;
				unJsonp(url, {
					jsonp: callback,
					jsonpcallback: callback
				}).then(
					(data: any) => {
						if (data.body.code == 200 || data.body.code == '0000') {
							this.isInvitationLive = true
						} else {
							this.$toast(data.body.msg)
						}
					}, (err: any) => {
					}
				)
			}
		}
	}
	//切换录播播放地址
	changePlay(data: any) {
		this.isSection = !data.isBackChange
		data.hlsURL = (data.hlsURL || "").replace("http:", "https:")
		this.setVideo(data.hlsURL);
	}
	//根据鼠标拖动的距离，换算进度条
	enhanceVideoSeek(percent: any) {
		clearInterval(this.timer);
		this.pvideo.currentTime = percent * this.pvideo.duration;
		console.log(this.pvideo.currentTime);
		this.timer = setInterval(this.setProgress, this.timeStep);
	}
	//设置进度条
	setProgress() {
		let progress: any = this.$refs.progress; //获取进度条父元素
		let onProgress: any = this.$refs.onProgress; //获取变化进度条的元素
		let mouseDom: any = this.$refs.mouseDom;
		this.currentTime = this.timeFomat(this.pvideo.currentTime); //当前播放的时间,格式化时间格式后展示
		this.duration = this.timeFomat(this.pvideo.duration || 0); //总时长，格式化时间格式后展示
		this.$forceUpdate();
		//换算,视频没有结束或者被暂停
		if (!this.pvideo.ended) {
			let percent = this.pvideo.currentTime / this.pvideo.duration; //得出比例
			mouseDom &&
				(mouseDom.style.left = percent * 100 + "%");
			onProgress &&
				(onProgress.style.width = percent * 100 + "%");
		} else {
			//视频已结束
			clearInterval(this.timer);
			this.timer = null;
		}
	}
	timeFomat(time: any) {
		let h = Math.floor(time / 3600);
		let m: any = Math.floor((time % 3600) / 60);
		let s: any = Math.floor(time % 60);
		m = m >= 10 ? m : "0" + m;
		s = s >= 10 ? s : "0" + s;
		if (h === 0) {
			return m + ":" + s;
		}
		return h + ":" + m + ":" + s;
	};
	claerScreen() {
		const currentTime = Date.now()
		const isSingleClick = currentTime - this.prevTime > 300
		this.prevTime = currentTime
		if (isSingleClick) {
			this.thumbsUpTime = setTimeout(() => {
				clearTimeout(this.thumbsUpTime)
				let data = this.$store.getters['environment/getClearScreen']
				this.$store.dispatch('environment/getClearScreenAsync', !data)
				this.thumbsUpTime = null
			}, 300);
		} else {
			clearTimeout(this.thumbsUpTime)
			if (!_intercept()) {
				return false;
			}
			this.$store.dispatch("timing/setIsRewardClickAsync", true);
			// clearTimeout(this.timer1);
			// this.timer1 = null;
			setTimeout(() => {
				this.$store.dispatch("timing/setIsRewardClickAsync", false);
			}, 500)

			// if (this.clickNum % 2 == 0) {
			this.$store.dispatch("timing/setLikeAsync", this.likeNum + 1);
			// }
			// clearTimeout(this.timer2);
			// this.timer2 = null;
			this.fetch({
				url: this.api.submitLike,
				data: {
					room_name: this.$route.params.roomNumber,
					likes: 1,
				},
			}).then((data: any) => {
				if (data.likes > this.likeNum) this.$store.dispatch("timing/setLikeAsync", data.likes);
			});
		}
		// if (this.thumbsUpTime) {
		// 	// this.timer2 = setTimeout(() => {
		// 	// 	if (this.clickNum >= 2) {
		// 	// 		if (!_intercept()) {
		// 	// 			return false;
		// 	// 		}
		// 	// 	}
		// 	// 	this.clickNum = 0
		// 	// }, 300);
		// 	clearTimeout(this.thumbsUpTime)
		// 	this.thumbsUpTime = null
		// } else {
		// 	this.thumbsUpTime = setTimeout(() => {
		// 		clearTimeout(this.thumbsUpTime)
		// 		// let data = this.$store.getters['environment/getClearScreen']
		// 		// this.$store.dispatch('environment/getClearScreenAsync', !data)
		// 		this.thumbsUpTime = null
		// 	}, 300);
		// }
	}
	// timer1: any = null;
	// dbUp() {
	// 	if (this.clickNum >= 2) {
	// 	}
	// }
	// timer2: any = null;
	// dbDown() {
	// 	this.clickNum++;
	// }
	downLoad() {
		location.href = 'https://h5.ule.com/hd/zone/uleapp/index.html'
	}
	openEffects(): void {
		let bool = !this.clearScreen;
		if (bool) return
		this.$store.dispatch('environment/getClearScreenAsync', bool)
	}
	init() {

		if (this.browser.ylxdsq) {
			_com.setTitle(document.title)
		}

		_com.systemTime((difference: number) => {
			this.difference = difference
			this.userEnterTime = new Date().getTime() + difference
		})
		this.currentDate = formatDate(new Date(), 'yyyy-MM-dd')
		this.getRoomDetail(); // 房间详细
		this.$store.dispatch("environment/getClientTypeAsync", this.source);
		if (_com.getMallCookie() && this.source == 'uxd' && (this.browser.ylxd || this.browser.ylxdsq || this.browser.wxwork || (cookie.get('sub_sch') == 'jinfuxiaodian') || (this.$route.query.storeid && this.$route.query.shareId))) {
			this.$store.dispatch("getUserOnlyId/getUserOnlyIdAsync");
		}

		let timeNum = 0;
		this.timeInter = setInterval(() => {
			//定时
			timeNum++;
			if (timeNum % 2 == 0) this.online = navigator.onLine;
			if (timeNum % 5 == 0) {
				//获取网络是否在线
				this.getStatus();
			}

			if (timeNum % 60 == 0) {
				console.log('60秒一次');
				console.log(timeNum / 60);
				(<any>window).uleStatUtil.sendEvent('broadlive', 'ping', timeNum / 60);
			}
			Object.assign(this.roomData, this.$store.getters["refresh/getRoomDetail"]);
			if (timeNum % 10 == 0) {
				//获取商品切片素材
				// this.$store.dispatch("refresh/getGoodsMaterialAsync", {
				// 	id: this.$route.params.id,
				// 	source:this.$route.params.source || this.source}
				// );
				// 红包雨查询,未登录或者非直播状态或邮掌柜环境不刷新红包雨接口
				if (!_com.getMallCookie() || this.videoStatus.roomStatus != 1 || this.browser.yzg || this.source == 'uzg') {
					return false;
				}
				this.packInit()

			}
		}, 1000);

	}
	wxConFig(isYsh: boolean) {
		console.log('设置分享')
		let roomNumber: any = this.$route.params.roomNumber;
		let appId = (this.domain.indexOf('beta') >= 0) ? 'wx8b73da0067c52318' : 'wx174a5809f2b70161';//必须是服务号id！！！
		//  wx8b73da0067c52318 (beta) wxc0bdbc30eff80e50(testing  邮乐购公众号)  wx174a5809f2b70161(生产邮乐VIP公众号)
		let href = (location.hostname == 'localhost') ? ('https://h5' + this.domain + location.pathname) : location.href;
		let url = `https://service${this.domain}/api/mobile/getWechatSignature.do`
		let signature: any = sessionStorage.getItem("signature")
		if (signature) {
			signature = JSON.parse(signature)
			if (signature[roomNumber] && signature[roomNumber].href == location.href) {
				this.config(appId, signature[roomNumber].data, isYsh)
				return
			}
		} else {
			signature = {}
		}
		jsonp(url, {
			jsonp: 'jsonApiCallback',
			lotteryInfoId: 325,
			currentPageUrl: href,
			appkey: '4b9f40822ddd5cd5',
			version_no: 'apr_2010_build01',
			appId: appId,
			t: Math.random()
		}).then((data: any) => {
			// alert(JSON.stringify(data))
			console.log('dfs');
			this.config(appId, data.detail[0], isYsh)
			signature[roomNumber] = {
				data: data.detail[0],
				href: location.href
			}
			sessionStorage.setItem("signature", JSON.stringify(signature));
		}).catch((err: any) => {
			// alert(JSON.stringify(err))
			// alert(JSON.stringify(err))
		});
	}
	config(appId: any, data: any, isYsh: boolean) {
		if (appId) {
			console.log('检查接口流程', appId, data)
		}
		try {
			(<any>window).wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
				appId: appId, // 必填，公众号的唯一标识
				timestamp: data.timestamp, // 必填，生成签名的时间戳
				nonceStr: data.nonceStr, // 必填，生成签名的随机串
				signature: data.signature, // 必填，签名
				jsApiList: ['updateAppMessageShareData', 'onMenuShareAppMessage'],
				// jsApiList: ['onMenuShareAppMessage', 'error', 'openLocation'], // 必填，按需写
				// openTagList: ['wx-open-launch-weapp'], // 可选，需使用开放标签，如['wx-open-launch-app']
			})
		} catch (err) {
			console.log("err------->", err)
		}
		console.log('config执行了')
		this.setShareConfig()
	}
	// 分享设置
	setShareConfig() {
		let url = `https://ustatic${process.env.VUE_APP_URI_ULECDNDOMAIN}/mobilecommoncdn/live/shareLiveRoom/${this.$route.params.id}/${this.$route.params.roomNumber}/live_share_info`
		jsonp(url, {
			jsonp: "jsonpCallback",
			jsonpcallback: "live_share_info",
		}).then((res: any) => {
			console.log("res-------------->", res)
			if (res) {
				try {
					(<any>window).wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
						// (<any>window).wx.onMenuShareAppMessage({ 
						// 	title: res.main_title, // 分享标题
						// 	desc: res.sub_title, // 分享描述
						// 	link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
						// 	imgUrl: res.url, // 分享图标
						// 	success: function (e:any) {
						// 		// 设置成功
						// 		console.log("e1------------------>", '设置成功',  e)
						// 	},
						// 	fail: function (err:any) {
						// 		console.log("e1------------------>", '失败', err)
						// 	},
						// })
						(<any>window).wx.updateAppMessageShareData({
							title: res.main_title, // 分享标题
							desc: res.sub_title, // 分享描述
							link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: res.url, // 分享图标
							success: function (e: any) {
								// 设置成功
								console.log("e------------------>", '设置成功', e)
							},
							fail: function (err: any) {
								console.log("e------------------>", '失败', err)
							},
						})
					})
				} catch (err) {
					console.log('err------>', err)
					throw err
				}

			} else {
				this.setDefaultShareInfo()
			}
		}, (err: any) => {
			this.setDefaultShareInfo()
		})
	}

	setDefaultShareInfo() {
		let roomData = Object.assign({}, JSON.parse(sessionStorage.getItem('roomData') as string))
			(window as any).wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
				(window as any).wx.updateAppMessageShareData({
					title: roomData.title, // 分享标题
					desc: roomData.theme, // 分享描述
					link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: roomData.cover, // 分享图标
					success: function () {
						// 设置成功
					}
				})
			})
	}
	// 邮乐网小程序内分享
	wxmpShare() {
		let shareData: {
			title: string;
			path: string;
			imageUrl?: string;
		} = {
			title: this.roomData.title || document.title,
			path: '/pages/webView?pageUrl=' + encodeURIComponent(location.href),
		};
		if (this.roomData.baseTag3) {
			shareData.imageUrl = this.roomData.baseTag3;
		}
		console.log('wxmpShare =====', shareData);
		(<any>window).wx?.miniProgram?.postMessage({
			data: {
				type: 'setShareData',
				shareData: shareData
			}
		});
	}

	hideNotice() {
		if (this.roomData.proclamation == "" || !this.roomData.proclamation) return false;
		this.noticeBool = true;
		setTimeout(() => {
			this.noticeBool = false;
		}, 10000);
	}

	getRoomDetail() {
		// this.$store.dispatch("refresh/getInsuranceAsync", this.$route.params.roomNumber); //推荐位商品功能屏蔽
		//获取直播间信息
		this.$store.dispatch("getRoomDetail/getRoomDetailAsync", this.$route.params.id).then((data: any) => {
			this.roomData = data;
			if (data.invite_type == 1) { // 判断是不是邀请制直播
				if (!_intercept()) {
					return false
				} else {
					// 查询用户是否填写过邀请码
					let callback = 'callback'
					let url = `${this.api.queryInvitationCode}${this.$route.params.id}/${data.scene_id}/${Math.floor(new Date().getTime() / 5000)}/` + callback;
					unJsonp(url, {
						jsonp: callback,
						jsonpcallback: callback
					}).then(
						(data: any) => {
							if (data.body.code == 200 || data.body.code == '0000') {
								this.isInvitationLive = false  // 打开邀请码填写弹窗
							} else if (data.body.code == 20001) {//未登录
								_intercept()
							} else if (data.body.code == 20005) {//已填写过邀请码
								this.isInvitationLive = true  // 打开直播界面
							} else {
								this.isInvitationLive = true  // 打开直播界面
							}
						}, (err: any) => {
							if (err.body && err.body.msg || err.msg) {
								this.$toast(err.body.msg || err.msg)
							}
						}
					)
				}
			} else { // 如果不是 直接打开界面
				this.isInvitationLive = true
			}

			if (data.scene_type == 2) {
				this.isRecording = true;
				this.$store.dispatch("refresh/getGoodsMaterialAsync", {
					id: data.id,
					source: this.$route.params.source || this.source
				}
				);
			}
			// data.hlsURL = (data.hlsURL || "").replace("http:", "").replace("https:", "");
			data.hlsURL = (data.hlsURL || "").replace("http:", "https:")
			this.recordHsl = data.hlsURL
			this.getStatus();
			this.showPoster = true;
			this.$store.dispatch("refresh/getRecommendAsync", {
				roomNumber: data.roomNumber,
				source: this.$route.params.source || this.source
			}
			);
			// console.log('roomDat11111a', this.roomData)
			let isElderlyMode = localStorage.getItem('isElderlyMode')
			if (isElderlyMode && (this.browser.usqxcx||this.browser.weixin||this.browser.ylxdsq) && /u150314|u150301|u150336|213795|211674|207035/.test(data.roomNumber)) {
				this.$store.dispatch('environment/getElderlyModeAsync', JSON.parse(isElderlyMode))
			}
			let liveName = ''
			if (this.roomData.tvStatus == 0) liveName = '待开播'
			if (this.roomData.tvStatus == 1 && this.roomData.scene_type == '2') liveName = '回放'
			if (this.roomData.tvStatus == 2) liveName = '已结束'

			setTimeout(() => {
				// 直播间打开埋点
				_com.sendSensorTrack('LiveView', this.roomData, {
					// _com.sendSensorTrack('直播间浏览', this.roomData, {
					ylw_enter_source: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid'),
					ylw_live_id: this.roomData.id,
					ylw_live_name: this.roomData.title,
					ylw_live_type: liveName,
					roomNumber: this.roomData.roomNumber,
					scene_number: this.roomData.scene_number,
					theme: this.roomData.theme,
					ylw_adid: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid'),
				}, false, 'yshPoint')
				// _com.sendSensorTrack('直播间浏览', {}, this.roomData, false, 'yshPoint')

				// 分享后打开页面埋点
				_com.sendSensorTrack('ShareClickSuccess', this.roomData, {})
			}, 500)
			// this.$store.dispatch("refresh/getPhoneAsync", {//2022/6/7  中奖用户前置条件改为必有手机号    
			// 	scene_id: data.scene_id
			// });
			try {
				let cartData: any = localStorage.getItem('broadcast_cart') || null;
				if (cartData) {
					let nowTime = new Date().getTime()
					cartData = JSON.parse(cartData);
					for (const key in cartData) {
						if (data.scene_number && key == data.roomNumber && (cartData[key].scene_number != data.scene_number)) {
							delete cartData[key]
						} else if ((nowTime - cartData[key].time) > 1000 * 60 * 60 * 24) {//24小时
							delete cartData[key]
						}
					}
					if (JSON.stringify(cartData) == '{}') {
						localStorage.removeItem('broadcast_cart')
					} else {
						localStorage.setItem('broadcast_cart', JSON.stringify(cartData))
					}
				}
			} catch (error) {

			}
			// 邮乐网小程序内分享
			if (this.browser.ulexcx) {
				this.wxmpShare()
			}
		});
	}


	getisLucky() {//获取中奖历史
		console.log('点击');
		if (this.luckHistory.status == 2) {//正在抽奖
			this.$toast("正在开奖中...");
			return false
		}
		const callback = 'luck'
		let url = `${this.api.getisLucky}${this.$route.params.roomNumber}/${Math.floor(new Date().getTime() / 5000)}/` + callback + '?t=' + new Date().getTime();
		jsonp(url, {
			jsonp: callback,
			jsonpcallback: callback
		}).then(
			(data: any) => {
				this.userPhoneNumber['contactNumber'] = data.contactNumber
				this.userPhoneNumber['contactPhone'] = data.contactPhone
				this.luckHistoryData.isPrize = false
				data.lucks.forEach((item: any) => {
					if (item.flag == 1) {
						this.luckHistoryData.isPrize = true
					}
				});
				this.luckHistoryData.prizeArr = data.lucks;
				this.$store.dispatch('refresh/setIsShowPrizeHistoryAsync', true);
			}, (err: any) => {
				console.log(err);
			}
		)
	}

	getHls() {
		if (this.isquery) {
			return false
		} else {
			this.isquery = true
		}
		const callback = 'getHls'
		jsonp(`${this.api.getM3u8}/${this.$route.params.roomNumber}/${Math.floor(new Date().getTime() / 1000)}/${new Date().getTime()}/${callback}`, {
			roomName: this.$route.params.roomNumber,
			durationInSeconds: 1800000,
			jsonp: callback,
			jsonpcallback: callback
		}).then((data: any) => {
			setTimeout(() => {
				this.isquery = false
			}, 1000);
			data.hlsURL = (data.hlsURL || "").replace("http:", "").replace("https:", "");
			this.$store.dispatch("environment/getHlsAsync", data.hlsURL);
			this.setVideo(data.hlsURL);
		}).catch(() => {
			setTimeout(() => {
				this.isquery = false
			}, 1000);
		});
	}

	getStatus() {
		let url = `${this.api.getStatus}${this.$route.params.roomNumber}/roomStatus?t=${new Date().getTime()}`
		jsonp(url, {
			jsonp: "roomStatus",
			jsonpcallback: 'roomStatus'
		}).then(
			(data: any) => {
				if (this.isRecording) {
					data.tvStatus = 1
				}
				this.$store.dispatch("getRoomDetail/getStatusAsync", data);
				if (this.isRecording) {
					if (this.recordHsl && data.roomStatus == "1" && !this.isVideo) {
						this.setVideo(this.recordHsl);
					}
				} else if (data.roomStatus == "1" && data.tvStatus == 1 && !this.isVideo) {
					this.getHls();
				}
			},
			(data: any) => {
				if (data.code == "619") {
					this.$store.dispatch("getRoomDetail/getStatusAsync", {
						roomStatus: '0'
					});
				}
			}
		);
	}

	setVideo(hlsURL: string) {
		this.isVideo = true;
		this.showPlayBtn = true;
		//设置video播放路径
		this.$nextTick(() => {
			this.pvideo = this.$refs.trailer;
			let Hls = (<any>window).Hls;
			let video: any = document.getElementById("video");
			if (Hls.isSupported()) {
				let hls = new Hls();
				hls.loadSource(hlsURL);
				hls.attachMedia(video);
				hls.on(Hls.Events.MANIFEST_PARSED, () => {
					video.play();
				});
			} else if (video.canPlayType("application/vnd.apple.mpegurl")) {
				video.src = hlsURL;
				video.addEventListener("loadedmetadata", () => {
					video.play();
				});
			}
			if (this.isRecording) {
				let currentTime = localStorage.getItem(this.roomData.scene_id)
				if (currentTime) {
					this.pvideo.currentTime = currentTime;
					localStorage.removeItem(this.roomData.scene_id)
				}
			}
			video.addEventListener("play", () => {
				this.isShowLoading = false;
				this.showPoster = false;
				this.showPlayBtn = false;
				clearInterval(this.m3u8Timer);
				console.log("进入播放");
				if (this.isRecording) {
					this.isplay = true;
					this.timer = setInterval(this.setProgress, this.timeStep);
				}
			});

			video.addEventListener("pause", () => {
				console.log("进入暂停");
				this.showPlayBtn = true;
				this.isShowLoading = false;
				if (this.isRecording) {
					clearInterval(this.timer);
					this.timer = null;
					this.isplay = false
				}
				//alert('pause')
			});

			video.addEventListener("timeupdate", () => {
				this.isShowLoading = false;
			});

			video.addEventListener("waiting", () => {
				console.log("等待数据，并非错误");
				if (!this.showPlayBtn) {
					this.loadingText = "加载中，请稍候";
					this.isShowLoading = true;
				}
			});

			// video.addEventListener("stalled", () => {
			// 	console.log("网速失速");
			// 	// this.loadingText = '当前网络较差，正在加载中';
			// 	// this.isShowLoading = true;
			// });

			// video.addEventListener("durationchange", () => {
			// 	console.log(video.duration);
			// });

			// video.addEventListener("loadstart", (e: any) => {
			// 	console.log("提示视频的元数据已加载");
			// 	console.log(e);
			// });

			// video.addEventListener("loadeddata", function(e: any) {
			// 	console.log("提示当前帧的数据是可用的");
			// 	console.log(e);
			// });

			// video.addEventListener("progress", function(e: any) {
			// 	console.log("提示视频正在下载中");
			// 	console.log(e);
			// });

			// video.addEventListener("canplay", function(e: any) {
			// 	console.log("提示该视频已准备好开始播放");
			// 	console.log(e);
			// });

			// video.addEventListener("canplaythrough", (e: any) => {
			// 	//video.play();
			// 	console.log("提示视频能够不停顿地一直播放");
			// 	console.log(e);
			// });

			// video.addEventListener("ended", function(e: any) {
			// 	console.log("视频播放完了");
			// 	console.log(e);
			// });

			video.addEventListener("error", (e: any) => {
				console.log("错误方法:" + JSON.stringify(e));
				if (this.isRecording) {
					return false
				}
				if (this.errorNum == 0) {
					this.isVideo = false;
					this.getHls();
					this.errorNum++;
				} else {
					this.$dialog
						.alert({
							title: "提示",
							message: "有点小卡 请重试",
						})
						.then(() => {
							this.isVideo = false;
							this.getHls();
							this.errorNum++;
						});
				}
			});
			this.hideNotice();
		});
	}

	isReport(val: boolean) {//展示投诉
		if (!_intercept()) {
			return false;
		}
		if (this.videoStatus.roomStatus == 1) {//直播中
			this.isShowReport = val;
			this.hideOperat();
		} else {
			this.$toast("直播还未开始喲");
		}
	}
	hideDetailInfoModal(bool?: boolean) {
		console.log('close');
		
		this.$store.dispatch("environment/getIsShowDetailInfoAsync", bool || false);
	}
	hideGoodsList(bool?: boolean) {
		this.$store.dispatch("environment/getIsGoodsListAsync", bool || false);
		this.$store.dispatch("environment/getIfBatchTitleAsync", bool || false);
	}
	hideGoodsDetail(bool?: boolean) {
		this.$store.dispatch("environment/getIsGoodsDetailAsync", bool || null);
	}
	hideYlxdsqCart(bool?: boolean) {
		this.$store.dispatch("environment/getYlxdsqCartAsync", bool || false);
	}
	hideLuckCardModal(bool?: boolean) {
		this.$store.dispatch('refresh/setLuckCardAllDataAsync',{key:'showPop',value:bool || false});
	}
	hideLuckCardList(bool?: boolean) {
		this.$store.dispatch('refresh/setLuckCardAllDataAsync',{key:'showListPop',value:bool || false});
	}

	hideOperat(bool?: boolean) {
		this.$store.dispatch("environment/getIsShowOperatAsync", bool || false);
	}

	hideConpon(bool?: boolean) {
		this.$store.dispatch("environment/getIsShowConponAsync", bool || false);
	}

	reload() {
		location.reload();
	}

	playClick() {
		(<any>document.getElementById("video")).play();
	}
	setCurrentTime() {
		localStorage.setItem(this.roomData.scene_id, this.pvideo.currentTime)
	}
	destroyed() {
		clearInterval(this.timeInter);
		this.timeInter = null
		sessionStorage.packetCode = '';
	}
	closedModel() {
		let style: any = document.querySelectorAll('.allIcons')[0]
		style.style.display = 'block'
	}
	useConpon() {
		let goodsModal = this.$refs["goodsModal"] as any;
		if (goodsModal) {
			goodsModal.volumeShop();
		}
	}
	// 红包雨
	// 关闭红包雨
	packetClose() {
		this.isPacketStart = false
	}
	// 抽奖
	prizereceive() {
		(window as any).uleStatUtil.sendView(location.href, { relateType: 'redPackets', relateId1: this.roomData.scene_id, relateId2: this.activityCode.packetCode });
		let url = '//service' + this.domain + '/lottry/lottery/lottry';
		let channel: any = {
			'usq': '610001',
			'ule': '300000',
			'uxd': '600000',
			'uleapp': '200000',
		}
		jsonp(url, {
			activityCode: this.activityCode.packetCode,
			channel: channel[this.source] || '200000',
			liveRoomNum: this.$route.params.roomNumber,
			fieldId: "",
			deviceId: ""
		}).then((res: any) => {
			//抽中奖品
			let prizeInfos: any = res.content.prizeInfos[0];
			if (prizeInfos.prizeTypeDesc_v2 == '40600') {//2022.10.21余陈德确认50503奖品下线了，改为40600
				// if(prizeInfos.prizeType=='50503'){//产品确认将奖品类型40600改为50503
				this.isPacketSucc = true;
				//抽中活动奖励金
				this.prizeInfos = prizeInfos;
			} else {
				//其他奖品,目前只有活动奖金，万一设置错误给用户显示没抽中的提示
				this.packetFail({
					title: "这次没抢到哦换个姿势试试吧",
					text: " ",
				})
			}
		})
			.catch((err: any) => {
				this.packetFail({
					title: "这次没抢到哦换个姿势试试吧",
					text: " ",
				})
				// this.$toast(err.message);
			})
	}
	// 抽奖失败
	packetFail(params: any) {
		this.isPacketFail = true
		this.popFailData = params
	}
	// 红包雨结束后的事件
	packetEnd(count: number) {
		this.packetClose();
		this.succCount = count;//击中红包数量
		// 如果有击中，则请求抽奖
		if (count > 0) {
			// this.prizereceive()
			// this.handleMouseUp()
			this.isShoWanimating = true
		}
		// 弹出失败提示
		else {
			this.packetFail({
				title: "这次没抢到哦换个姿势试试吧",
				text: " ",
			})
		}
	}
	// 分享
	share() {
		this.isPacketFail = false;
	}
	// 红包雨查询
	packInit() {
		if (this.source == 'ysh') {//邮生活专属直播间不下红包雨
			return
		}
		// 如果红包雨进行中 则不请求
		// console.log('=====红包雨状态',this.isPacketStart)
		if (!this.isPacketStart) {
			let nowTimes = new Date().getTime();
			nowTimes = nowTimes + this.difference;
			// console.log(nowTimes);
			jsonp(this.api.redRainCode + `/${this.$route.params.roomNumber}/${Math.floor(nowTimes / 10000)}/callback`, {
				// room_name: this.$route.params.roomNumber,
				// roomNum: this.$route.params.roomNumber,
				timestamp: nowTimes,
				jsonp: 'callback',
				jsonpcallback: 'callback'
			}).then((data: any) => {
				// 选判断是否有code
				if (data.code) {
					// 获取活动code
					this.activityCode.packetCode = data.code;
					this.checkCode = data.code;
					// 判断是否在活动时间内并且当前的活动code与之前不同
					let packetCode = sessionStorage.packetCode || '';
					if ((nowTimes >= +data.start_time && nowTimes < +data.end_time) && packetCode != (data.start_time + data.code)) {
						this.isPacketStart = true;
						this.isPacketFail = false;//红包雨开始时关闭抽奖结果弹框
						this.isPacketSucc = false;//红包雨开始时关闭抽奖结果弹框
						sessionStorage.packetCode = data.start_time + data.code;
					} else {
						this.isPacketStart = false;
					}
				}
			}).catch(err => {
				console.log('err', err)
			});

		} else {
			return false;
		}
	}


}
